import React from 'react';
import CellWithIcon from './CellWithIcon';

const CellWithButtonIcon = ({ type, onClickIcon, size = 20 }) => {
    const cellWithIcon = CellWithIcon(type, size);

    return (
        <div className="table-cell_with-button-icon">
            <button type="button" onClick={onClickIcon}>
                {cellWithIcon}
            </button>
        </div>
    );
};


export default CellWithButtonIcon;
